import Control from "../../1. Core/Control";
import NP from "../../1. Core/NP";
import Delegate from "../../1. Core/Delegate";
import PageModePanelBattle from "./PageModePanel/PageModePanelBattle";

import AthletesList from "../../2. Athletes/AthletesList";
import StatesList from "../../2. Athletes/StatesList";
import BattlesList from "./Lists/BattlesList";
import JudgesList from "../../6. Judge/JudgesList";
import Select from "../../1. Core/Controls/Select/Select";
import {ServerAPI} from "../../1. Core/ServerAPI";
import {IAthlete, PageMode} from "../types";

import TEventList from "../TEvents/TEventList";
import AthletesRatingList from "../../2. Athletes/AthletesRatingList";
import WidgetList from "../WidgetManager/WidgetList";
import {getCurrentUser} from "../../1. Core/UserInfo";
import TournamentsPanel from "../../Admin/Tournament/TournamentsPanel";
import UsersPanel from "../../Admin/Users/UsersPanel";
import TrainersList from "../../7. Trainers/TrainersList";
import FantasyList from "../../5. Fantasy/FantasyList";
import CardList from "../../5. Fantasy/CardList";
import PushScheduleList from "../../Admin/PushScheduleList";
import NewsSourceList from "../../5. Fantasy/NewsSourceList";
import VideoSourceList from "../../5. Fantasy/VideoSourceList";
import PromocodeList from "../../5. Fantasy/PromocodeList";

export default class LibraryBoxBattle extends Control {
	private _contentNode: HTMLElement;
	private _PageMode: PageMode;
	private _OpenedObjectId: number;
	private _ThinWidth: number;
	private _currentPanel: AthletesList | StatesList | BattlesList | JudgesList | FantasyList | TEventList | AthletesRatingList | WidgetList | TournamentsPanel | UsersPanel | TrainersList | CardList | PushScheduleList | NewsSourceList | VideoSourceList | PromocodeList;
	private _pageModePanel: PageModePanelBattle;
	public EvExportForSlack: Delegate;
	public EvExport: Delegate;
	public EvReportOpened: Delegate;
	public EvListLoaded: Delegate;
	public EvNewObject: Delegate;
	public EvPermissionTypeChanged: Delegate;
	public EvPageModeChanged: Delegate;
	private _bannerNode: HTMLElement;
	private _dummyPanel: HTMLElement;

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this._PageMode = null;
		this._OpenedObjectId = null;
		this._ThinWidth = 1024;

		this.EvExport = new Delegate();
		this.EvReportOpened = new Delegate();
		this.EvListLoaded = new Delegate();
		this.EvNewObject = new Delegate();
		this.EvPermissionTypeChanged = new Delegate();
		this.EvPageModeChanged = new Delegate();
		this.EvExportForSlack = new Delegate();
		super._initFields(settings);
	}

	getPageMode()
	{
		return this._PageMode;
	}


	_render()
	{
		this.np_render(`<div class="librarybox-battle">
<div class="mdc-drawer-scrim"></div>
<div class="librarybox-battle__content-node"></div>
</div>`);

		this._contentNode = this._root.querySelector('.librarybox-battle__content-node');


		this._pageModePanel = new PageModePanelBattle({
			EvItemSelected: (sender: Control, args: { PageMode: PageMode }) =>
			{
				if (args.PageMode)
				{
					this.setOpenedObjectId(null);
					this.setPageMode(args.PageMode);
				}
			}
		});

		this._pageModePanel.putToNode(this._root, this._root.querySelector('.mdc-drawer-scrim'));

		let pageMode = this._PageMode || getCurrentUser().getFeatures()[0] || PageMode.mmaathletes;
		this._PageMode = null;
		this.setPageMode(pageMode, false, this._OpenedObjectId);

		if (this._isThin())
		{
			let fb = this._currentPanel.getTopAppBar().getItem('Filters');
			if (fb)
				fb.EvClick.fire(fb);
		}
	}


	setPageMode(value: PageMode, fireEvent?: boolean, openedObjectId?: number, isPush = false)
	{
		if (value != this._PageMode || openedObjectId != this._OpenedObjectId)
		{
			this._OpenedObjectId = openedObjectId;
			this._PageMode = value;

			this.refresh(isPush);

			if (fireEvent !== false)
				this.EvPageModeChanged.fire(this, {Mode: this._PageMode});
		}
	}


	setOpenedObjectId(value: number)
	{
		this._OpenedObjectId = value;
	}

	refreshTitle()
	{

	}


	refresh(isPush: boolean = false)
	{
		this.refreshTitle();
		this._pageModePanel.selectPageMode(this._PageMode);
		this._refreshPageModeLabel();

		let currentVisRightPanel = this._currentPanel?.getTopAppBar().getItem('Filters')?.getData();

		if (this._currentPanel)
			(this._currentPanel as Control).destroy();
		this._currentPanel = null;

		if (this._contentNode.contains(this._dummyPanel))
			this._contentNode.removeChild(this._dummyPanel);

		if (getCurrentUser().getIsAdmin() || getCurrentUser().getFeatures().find(f => f == this._PageMode))
			switch (this._PageMode)
			{
				case PageMode.kickboxers:
				case PageMode.boxers:
				case PageMode.mmaathletes:
					this._currentPanel = new AthletesList({
						ParentNode: this._contentNode,
						Mode: this._PageMode,
						OpenedItemId: this._OpenedObjectId,
						EvAthleteOpened: (s: object, e: { Athlete: IAthlete }) => {
							this._OpenedObjectId = e.Athlete.Id;
						},
						EvShowPageModeClick: () => this._appBarMainButtonClick()
					});
					break;
				case PageMode.mmastates:
				case PageMode.states:

					this._currentPanel = new StatesList({
						PageMode: this._PageMode,
						ParentNode: this._contentNode,
						EvShowPageModeClick: () => this._appBarMainButtonClick()
					});
					break;
				case PageMode.boxrefereeing:
				case PageMode.mmarefereeing:

					this._currentPanel = new JudgesList({
						ParentNode: this._contentNode,
						Mode: this._PageMode,
						EvShowPageModeClick: () => this._appBarMainButtonClick()
					});
					break;
				case PageMode.trainers:
					this._currentPanel = new TrainersList({
						ParentNode: this._contentNode,
						Mode: this._PageMode,
						EvShowPageModeClick: () => this._appBarMainButtonClick()
					});
					break
				case PageMode.kbbouts:
				case PageMode.boxresults:
				case PageMode.mmaresults:
					this._currentPanel = new BattlesList({
						ParentNode: this._contentNode,
						Mode: this._PageMode,
						OpenedItemId: this._OpenedObjectId,
						EvShowPageModeClick: () => this._appBarMainButtonClick()
					});
					break;
				case PageMode.fantasy:
					if (NP.getCurrentUser().isFantasyAvailable())
					{
						this._currentPanel = new FantasyList({
							ParentNode: this._contentNode,
							EvShowPageModeClick: () => this._appBarMainButtonClick()
						})
					}
					else
						return;
					break;
				case PageMode.newssource:
					this._currentPanel = new NewsSourceList({
						ParentNode: this._contentNode,
						EvShowPageModeClick: () => this._appBarMainButtonClick()
					})
					break;
				case PageMode.promocodes:
					this._currentPanel = new PromocodeList({
						ParentNode: this._contentNode,
						EvShowPageModeClick: () => this._appBarMainButtonClick()
					})
					break;
				case PageMode.videosource:
					this._currentPanel = new VideoSourceList({
						ParentNode: this._contentNode,
						EvShowPageModeClick: () => this._appBarMainButtonClick()
					})
					break;
				case PageMode.cardsfantasy:
					if (NP.getCurrentUser().getIsAdmin())
					{
						this._currentPanel = new CardList({
							ParentNode: this._contentNode,
							EvShowPageModeClick: () => this._appBarMainButtonClick()
						})
					}
					break;
				case PageMode.kbevents:
				case PageMode.mmaevents:
				case PageMode.boxevents:
					this._currentPanel = new TEventList({
						ParentNode: this._contentNode,
						Mode: this._PageMode,
						OpenedItemId: this._OpenedObjectId,
						EvShowPageModeClick: () => this._appBarMainButtonClick()
					});
					break;
				case PageMode.kbhighlights:
				case PageMode.mmahighlights:
				case PageMode.bookmaker:
					this._currentPanel = new TEventList({
						ParentNode: this._contentNode,
						Mode: this._PageMode,
						OpenedItemId: this._OpenedObjectId,
						EvShowPageModeClick: () => this._appBarMainButtonClick()
					});
					break;
				case PageMode.mmarating:
					this._currentPanel = new AthletesRatingList({
						ParentNode: this._contentNode,
						Mode: this._PageMode,
						EvShowPageModeClick: () => this._appBarMainButtonClick(),
						EvAthleteOpened: (s: object, e: { Athlete: IAthlete }) =>
						{
							this.setPageMode(PageMode.mmaathletes, true, e.Athlete.Id, true);
						}
					});
					break;
				case PageMode.widgets:
					this._currentPanel = new WidgetList({
						ParentNode: this._contentNode,
						Mode: this._PageMode,
						EvShowPageModeClick: () => this._appBarMainButtonClick()
					});
					break;

				case PageMode.tournaments:
					this._currentPanel = new TournamentsPanel({
						ParentNode: this._contentNode,
						Mode: this._PageMode
					});
					break;
				case PageMode.players:
				case PageMode.users:
					this._currentPanel = new UsersPanel({
						ParentNode: this._contentNode,
						OpenedItemId: this._OpenedObjectId,
						Mode: this._PageMode
					});
					break;
				case PageMode.push:
					this._currentPanel = new PushScheduleList({
						ParentNode: this._contentNode
					});
					break;
			}

		this._currentPanel.refresh();
		NP.updateBrowserUrlString(isPush, this._PageMode, this._OpenedObjectId);

		this._updateWidth();
		this._updateHeight();
		this.refreshBtns();

		if (this._currentPanel)
		{
			let fb = this._currentPanel.getTopAppBar().getItem('Filters');
			this._currentPanel.getTopAppBar().addItem(this.getLangSelect() as any, fb);

			if (fb && currentVisRightPanel)
				fb.EvClick.fire(fb);
		}
	}

	getTopAppBar()
	{
		return this._currentPanel && this._currentPanel.getTopAppBar && this._currentPanel.getTopAppBar();
	}

	_refreshPageModeLabel()
	{

	}

	getLangSelect()
	{
		return new Select({
			ParentNode: this._root,
			Width: 150,
			Value: getCurrentUser().getUILang(),
			Items: [{
				Value: "ru",
				ToolTip: "Russian",
				Content: "Русский"
			}, {
				Value: "en",
				ToolTip: "English",
				Content: "English"
			}, {
				Value: "zh",
				ToolTip: "中文",
				Content: "中文"
			}],
			EvItemSelected: (s: Select) =>
			{
				let usr = getCurrentUser()
				ServerAPI.post('/users/current', {
					Email: usr.getEmail(),
					FirstName: usr.getFirstName(),
					LastName: usr.getLastName(),
					UILang: s.getValue()
				}).then(() => window.location.reload());
			}
		})
	}

	refreshBtns()
	{
		this._refreshPageModeLabel();
	}


	_isThin()
	{
		return this._Width <= this._ThinWidth;
	}

	setWidth(value: number)
	{
		if (value != this._Width)
		{
			super.setWidth(value);
			this._updateWidth();
		}
	}

	_updateWidth()
	{
		this._refreshThin();
		if (this._currentPanel)
		{
			let w = this._isThin() || !this._pageModePanel.getIsVisible() ? this.getWidth() : this.getWidth() - this._pageModePanel.getOffsetWidth();
			this._currentPanel.setWidth(w);
		}
	}

	_refreshThin()
	{
		let appBar = this.getTopAppBar();
		if (this._isThin())
		{
			if (appBar)
				appBar.getMainButton().show();
		}
		else
		{
			if (appBar)
				appBar.getMainButton().hide();
		}
	}

	_appBarMainButtonClick()
	{
		this._pageModePanel.modalOpenOrHide();
	}

	_onClicked()
	{
		this._pageModePanel.modalClose();
	}

	setHeight(value: number)
	{
		if (value != this._Height)
		{
			super.setHeight(value);
			this._updateHeight();
		}
	}

	hide()
	{
		super.hide();
		if (this._bannerNode)
			NP.hide(this._bannerNode);
	}

	show()
	{
		super.show();
		if (this._bannerNode)
			NP.show(this._bannerNode);
	}

	_updateHeight()
	{
		if (this._currentPanel)
		{
			let bannerHeight = NP.getCurrentUser().getBanner() ? 40 : 0;
			this._currentPanel.setHeight(this._Height - bannerHeight);
		}
	}

	getCurrentPanel()
	{
		return this._currentPanel;
	}
}
